import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Subject";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from 'rxjs';
import { ModalComponent } from "./modal.component";
import { DialogProperties } from "../../utils/dialogProperties";
//import { BehaviorSubject }    from 'rxjs/BehaviorSubject';

@Injectable()
export class ModalService {

	closeResult:string

	private subject = new Subject<any>();

	constructor(protected ngbService: NgbModal) {}

	confirm(header: string,message: string, siFn: Function = ()=>{}, noFn: Function = ()=>{}){
		this.setConfirmation(header, message, siFn, noFn);
	}

	confirmPromise(header: string,message: string, siFn: Function = ()=>{}, noFn: Function = ()=>{}){
		return new Promise((resolve, reject) => {
			this.setConfirmation(header, message, resolve, reject);
		})
	}

	information(header: string, message: string, siFn: Function = ()=>{}){
		this.setInformation(header, message, siFn);
	}

	template(header: string, template, siFn: Function = ()=>{}){
		let that = this;
		this.subject.next({ 
			type: "template",
			header : header,
			text: template,
			siFn:
			function(){
				that.subject.next();
				siFn();
			},
		});
	}

	/*
	open(message: string, title?: string, typeModal?) {
		//const modalRef =
		 let modal = this.ngbService.open(ModalComponent);
		modal.componentInstance.message = message;
		modal.componentInstance.title = title;
		modal.componentInstance.typeModal = typeModal;

		modal.result.then(result => {
			//modalRef.componentInstance.name = 'Test Modal';
			return result;
		});

	}
	*/
 
	setConfirmation(header: string, message: string, siFn: Function = ()=>{}, noFn: Function = ()=>{}) {
		let that = this;
		this.subject.next({ 
			type: "confirm",
			header : header,
			text: message,
			siFn:
			function(){
				that.subject.next();
				siFn();
			},
			noFn:function(){
				that.subject.next();
				if(noFn)
					noFn();
			}
		});
	}

	setInformation(header: string, message: string, siFn: Function = ()=>{}) {
		let that = this;
		this.subject.next({ 
			type: "information",
			header : header,
			text: message,
			siFn:
			function(){
				that.subject.next();
				siFn();
			},
		});
	}

	getMessage(): Observable<any> {
		return this.subject.asObservable();
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal.service.ts